<gl-base-modal (closeModal)="close()" [disableCloseButton]="true">
  @if (data?.messageKey) {
    <h2 class="title">{{ (data.headerKey ?? 'warning') | translate }}</h2>
    <p class="info">{{ data.messageKey | translate }}</p>
  } @else {
    <h2 class="title">{{ 'error_page_header' | translate }}</h2>
    <p class="info">{{ 'error_page_message' | translate }} <a (click)="closeWithRedirect()" class="homepage-link">{{ 'error_homepage_link' | translate }}</a>.</p>
  }
  <div class="buttons">
    <button outline-button (click)="close()">{{ 'close' | translate }}</button>
  </div>
</gl-base-modal>
